import { FC } from "react";
import { Updater } from "use-immer";

import { IgButton } from "@intelligems/ig-theme";
import { Stack } from "@mui/system";

interface IntervalOption {
  value: string;
  label: string;
  borderRadius?: {
    left?: boolean;
    right?: boolean;
  };
}

const defaultButtons: IntervalOption[] = [
  {
    value: "HOUR",
    label: "Hourly",
    borderRadius: { left: true },
  },
  {
    value: "DAY",
    label: "Daily",
  },
  {
    value: "WEEK",
    label: "Weekly",
    borderRadius: { right: true },
  },
];

interface MobileGraphIntervalButtonsProps {
  graphInterval: string;
  hasNoData: boolean;
  isLoading: boolean;
  setGraphInterval: Updater<string>;
  intervals?: IntervalOption[];
}

export const MobileGraphIntervalButtons: FC<
  MobileGraphIntervalButtonsProps
> = ({ setGraphInterval, graphInterval, intervals = defaultButtons }) => {
  const buttons = intervals.map((interval) => (
    <IgButton
      value={interval.value}
      key={interval.value}
      size="small"
      sx={{ fontSize: 12 }}
      onClick={() => {
        setGraphInterval(interval.value);
      }}
      variant={graphInterval === interval.value ? "contained" : "outlined"}
    >
      {interval.label}
    </IgButton>
  ));

  return (
    <Stack direction="row" spacing={2}>
      {buttons}
    </Stack>
  );
};
